//历史考试列表
export const EXAMS_GET_LIST = "EXAMS_GET_LIST";
export const EXAMS_GET_BE_LIST = "EXAMS_GET_BE_LIST";
//获取会员信息
export const GET_MEMBERS = "GET_MEMBERS";
//获取会员资格
export const GET_MEMBER_SHIPS = "GET_MEMBER_SHIPS";



// WEBPACK FOOTER //
// ./src/views/ReportApp/store/types/types_exams.js